import styled from 'styled-components';

export const Text = styled.p`
  left: 50%;
  top: 28px;
  z-index: 1;
  display: none;
  color: #6F7074;
  font-size: 12px;
  margin: auto;
  position: absolute;
  transform: translateX(-50%);
  background: #2e3136;
  color: #d7d7d8;
  padding: 10px;
  line-height: 13px;
  width: fit-content;
  /* max-width: 580px; */
  /* width: fit-content; */
  /* white-space: break-spaces; */

  &:after {
    content: '';
    left: 50%;
    top: -6px;
    margin: auto;
    position: absolute;
    transform: translateX(-50%);
    border-style: solid;
    border-width: 0 6px 6px 6px;
    border-color: transparent transparent #2e3136 transparent;
  }
`;

export const Container =  styled.div`
  cursor: pointer;
  position: relative;
  text-decoration: none;
  border-bottom: dashed 1px #b5b5b5;

  &:hover {
    ${Text} {
      display: block;
    }
  }
`;
